import { useQuery } from 'react-apollo';
import moment from 'moment';
import * as query from 'queries/IdeaQuery/query.gql';
import {
  IdeaQuery,
  IdeaQueryVariables,
  IdeaQuery_lab_idea as Idea,
  IdeaQuery_lab_investmentNotArchivedBuyOrders_list as InvestmentBuyOrder,
} from 'queries/IdeaQuery/__generated__/IdeaQuery';

const getIsExpired = (idea: Idea) => {
  const { properties } = idea;

  switch (properties.__typename) {
    case 'Investment_BuyAndHoldIdeaProperties':
      return properties.manualStartDate && moment().isAfter(properties.manualStartDate);
    case 'Investment_LimitedIdeaProperties':
      return properties.finishRequestDate && moment().isAfter(properties.finishRequestDate);
    default:
      return false;
  }
};

export const useIdeaLanding = (id: number) => {
  const { data, loading } = useQuery<IdeaQuery, IdeaQueryVariables>(query, {
    variables: {
      id,
    },
    errorPolicy: 'all',
  });

  const idea = data?.lab.idea;
  const activeBuyOrderId = (
    data?.lab.investmentNotArchivedBuyOrders.list.find(
      (val) => val != null
    ) as InvestmentBuyOrder | null
  )?.id;

  return {
    loading,
    idea,
    isExpired: !!(idea && getIsExpired(idea)),
    activeBuyOrderId,
  };
};
